import { Rate } from "antd"

import { ICardApplicationTabPrimaryUI } from "./types"

import { SelectDate } from "@primitive/calendar"
import { getInputButton } from "@primitive/getInputButton"
import { DictSelectorContainer } from "@smart/dictSelector/ui.container"

import { Container, Divider, Flex, Input, Textarea, Toogle } from "@ui/index"

import css from './ui.module.scss'


/** UI - Вкладка основные данные */
export const CardApplicationTabPrimaryUI = ({
    dbNameList, dbNameSelected, fieldsError, isFieldsDisabled,
    txtClientName, txtClientPhone, txtClientEmail, txtProgramType, txtProgramTypeID,
    txtDurationEducation, txtProgramSum, txtEducationDateStart, txtEducationDateEnd, 
    txtApplicationStatusID, txtTimeNextCall, txtDateNextCall, txtApplicationComment,
    txtProgramName, txtProgramNameID, txtAttestationType, txtVolumeHours,
    txtApplicationStatus, txtApplicationType, txtApplicationSource, txtClientRating,
    handleChangePhone,  
    dictSelectorData, txtEducationDateStartOnChange, txtEducationDateEndOnChange, 
}: ICardApplicationTabPrimaryUI) => {
    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>База данных сайта</h4>} />

                <Flex gap="8px" flexDirection="row" flexWrap="wrap">
                    {dbNameList.length === 0 ? 'Базы данных не найдены' 
                        : dbNameList.map((item) => (
                            <Container padding="4px 3px 4px 10px" key={item.siteDbNameID} className={css['gr_1fr_auto']}>
                                <p>{item.siteDbNameDescription}</p>

                                <Toogle 
                                    checked={dbNameSelected.value === item.siteDbName ? true : false} 
                                    onChange={() => dbNameSelected.setValue(item.siteDbName)} 
                                />
                            </Container>
                        ))
                    }
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>О клиенте</h4>} 
                    suffix={<Rate allowHalf value={txtClientRating.value} onChange={txtClientRating.setValue} style={{color: 'var(--color_bg_accent)'}} />}
                />

                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.clientName ? 'input_error' : 'input_error input_error-active'}>
                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Имя клиента <p className="pulse"></p></Flex>
                        
                        <Input placeholder="Имя клиента" {...txtClientName}
                            suffix={txtClientName.value && getInputButton('clear', txtClientName.reset)} 
                        />
                    </Flex>

                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.clientPhone ? 'input_error' : 'input_error input_error-active'}>
                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Телефон клиента</Flex>
                        
                        <Input placeholder="Телефон клиента"  
                            value={txtClientPhone.value} onChange={(e) => handleChangePhone(e.target.value)}
                            suffix={txtClientPhone.value && getInputButton('clear', () => handleChangePhone(''))}
                        />
                    </Flex>

                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.clientEmail ? 'input_error' : 'input_error input_error-active'}>
                        <Flex flexDirection="row" className="input_header">Email клиента</Flex>
                        
                        <Input placeholder="Email клинета" {...txtClientEmail}
                            suffix={txtClientEmail.value && getInputButton('clear', txtClientEmail.reset)} 
                        />
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>Программа обучения</h4>} />

                <Flex gap="15px">
                    <Flex flexGrow={1} className={!fieldsError.value.programName ? 'input_error' : 'input_error input_error-active'}>
                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Наименование программы <p className="pulse"></p></Flex>
                        
                        <Input placeholder="Наименование программы" isReadOnly {...txtProgramName}
                            suffix={
                                <DictSelectorContainer dbName={dbNameSelected.value} dictName="courses" 
                                    onSelect={(data) => {dictSelectorData('courses', data)}}
                                >{getInputButton('select')}</DictSelectorContainer>
                            }  
                        />
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.programType ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип программы <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Тип программы" {...txtProgramType}
                                isReadOnly isDisabled={isFieldsDisabled.value}
                                suffix={
                                    <DictSelectorContainer isSearch={false} isScroll={false}
                                        dbName={dbNameSelected.value} dictName="programType" 
                                        whereParam1={txtProgramNameID.value.toString()}
                                        onSelect={(data) => { dictSelectorData('programType', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                } 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.attestationType ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип аттестации <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Тип аттестации" isReadOnly {...txtAttestationType}
                                isDisabled={isFieldsDisabled.value || txtProgramTypeID.value === 2}  
                                suffix={
                                    <DictSelectorContainer isSearch={false} isScroll={false}
                                        dbName={dbNameSelected.value} dictName="attestationType" 
                                        whereParam1={txtProgramNameID.value.toString()}
                                        onSelect={(data) => { dictSelectorData('attestationType', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.durationEducation ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Продолжительность ({txtProgramTypeID.value === 1 ? 'месяцы' : 'недели'}) <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Продолжительность" isReadOnly {...txtDurationEducation} 
                                isDisabled={isFieldsDisabled.value} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.volumeHours ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Объём программы (часы) <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Объём программы" isReadOnly {...txtVolumeHours}
                                isDisabled={isFieldsDisabled.value}
                                suffix={
                                    <DictSelectorContainer dbName={dbNameSelected.value} dictName="volumeHours" 
                                        whereParam1={txtProgramNameID.value.toString()} whereParam2={txtProgramTypeID.value.toString()}
                                        onSelect={(data) => { dictSelectorData('volumeHours', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.programSum ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Стоимость программы (рубли) <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Стоимость программы" isDisabled={isFieldsDisabled.value} 
                                suffix={txtProgramSum.value && getInputButton('clear', txtProgramSum.reset)}
                                value={txtProgramSum.value} onChange={(e) => txtProgramSum.setValue(e.target.value.trim())}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.educationDateStart ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата начала обучения <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Дата начала обучения" 
                                type='mask' mask='99.99.2099' isDisabled={isFieldsDisabled.value} 
                                value={txtEducationDateStart.value} onChange={(e) => txtEducationDateStartOnChange(e.target.value)}
                                suffix={<>
                                    {txtEducationDateStart.value && getInputButton('clear', () => txtEducationDateStartOnChange(''))}

                                    <SelectDate currentDate={txtEducationDateStart.value} onSelect={txtEducationDateStartOnChange}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.educationDateEnd ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата окончания обучения <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Дата окончания обучения" 
                                type='mask' mask='99.99.2099' isDisabled={isFieldsDisabled.value} 
                                value={txtEducationDateEnd.value} onChange={(e) => txtEducationDateEndOnChange(e.target.value)}
                                suffix={<>
                                    {txtEducationDateEnd.value && getInputButton('clear', txtEducationDateEnd.reset)}

                                    <SelectDate currentDate={txtEducationDateEnd.value} onSelect={(date) => { txtEducationDateEnd.setValue(date) }}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>} 
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>О заявке</h4>} />

                <Flex gap="15px">
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.applicationStatus ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Статус заявки <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Статус заявки" isReadOnly {...txtApplicationStatus}
                                suffix={
                                    <DictSelectorContainer dbName={dbNameSelected.value} dictName="applicationStatus"
                                        onSelect={(data) => { dictSelectorData('applicationStatus', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.dateNextCall ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата отложенного действия {txtApplicationStatusID.value === 2 && <p className="pulse"></p>}</Flex>
                            
                            <Input placeholder="Дата отложенного действия" {...txtDateNextCall}
                                type='mask' mask='99.99.2099' isDisabled={txtApplicationStatusID.value !== 2} 
                                suffix={<>
                                    {txtDateNextCall.value && getInputButton('clear', txtDateNextCall.reset)}

                                    <SelectDate currentDate={txtDateNextCall.value} onSelect={(date) => { txtDateNextCall.setValue(date) }}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>}  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.timeNextCall ? 'input_error' : 'input_error input_error-active'}>
                            <Flex flexDirection="row" className="input_header">Время отложенного действия</Flex>
                            
                            <Input placeholder="Время отложенного действия" {...txtTimeNextCall} 
                                type='mask' mask='99:99:00' isDisabled={txtApplicationStatusID.value !== 2} 
                                suffix={txtTimeNextCall.value && getInputButton('clear', txtTimeNextCall.reset)} 
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.applicationType ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип заявки <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Тип заявки" isReadOnly {...txtApplicationType}
                                suffix={
                                    <DictSelectorContainer isSearch={false} isScroll={false}
                                        dbName={dbNameSelected.value} dictName="applicationType"
                                        onSelect={(data) => { dictSelectorData('applicationType', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.applicationSource ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Источник заявки <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Источник заявки" isReadOnly {...txtApplicationSource}
                                suffix={
                                    <DictSelectorContainer dbName={dbNameSelected.value} dictName="applicationSource"
                                        onSelect={(data) => { dictSelectorData('applicationSource', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>
                    </Flex>

                    <Flex flexGrow={1}>
                        <Flex flexDirection="row" className="input_header">Комментарий к заявке</Flex>

                        <Textarea placeholder="Комментарий к заявке" rows={5} 
                            value={txtApplicationComment.value} 
                            onChange={(e) => txtApplicationComment.setValue(e.target.value)} 
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    </>
}